import { queryOptions, type QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { getTraumaCatalog } from "./catalog.functions";
import { traumaGateRedirect } from "./public-gate";

export const traumaCatalogQuery = () =>
  queryOptions({ queryKey: ["trauma", "catalog"], queryFn: () => getTraumaCatalog(), staleTime: 30_000 });

/**
 * Loader gate. SSR has no bearer token, so a hidden catalog redirects there;
 * in the browser the call carries the session and the server lets admins in.
 */
export async function loadTraumaCatalogOrRedirect(queryClient: QueryClient) {
  const catalog = await queryClient.fetchQuery(traumaCatalogQuery());
  const r = traumaGateRedirect(Boolean(catalog));
  if (r || !catalog) throw redirect({ to: r?.to ?? "/", statusCode: 302, replace: true });
  return catalog;
}
